'use client';

import type { ChangeEvent } from 'react';
import type React from 'react';
import { IMaskInput } from 'react-imask';

import { FormGroup } from '../../templates/form-group/form-group';
import type { ZipCodeInputProps } from './zip-code-input.types';

function getContainerStyle(withButton: boolean) {
  if (withButton)
    return 'hc-input__container--with-button hc-sidebar-layout--reverse';

  return '';
}

export function ZipCodeInput({
  label,
  name,
  placeholder,
  disabled = false,
  withButton = false,
  value,
  onChange,

  icon = null,
  helpText = '',
  errorText = '',
  error = false,
  id,
  button,
  className,
  required = false,
  onBlur,
  ref,
  'data-testid': dataTestId,
}: ZipCodeInputProps & {
  ref?: React.Ref<HTMLInputElement>;
}) {
  const showErrors = error;

  return (
    <FormGroup className={className} disabled={disabled} error={showErrors}>
      <label className="hc-label">
        {label}
        <div className={getContainerStyle(withButton)}>
          <div className="hc-form-control--icon-right relative">
            <IMaskInput
              onBlur={onBlur}
              onAccept={(_v, _r, e) => {
                if (e) {
                  // Required to work with react hook form as IMask Uses onAccept instead of onChange.
                  onChange?.(e as unknown as ChangeEvent<HTMLInputElement>);
                }
              }}
              inputRef={ref}
              mask="text"
              blocks={{
                text: {
                  mask: /^\d+$/i,
                },
              }}
              maxLength={5}
              minLength={5}
              lazy={false}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
              name={name}
              id={id || name}
              aria-invalid={showErrors}
              value={value}
              type="tel"
              data-testid={dataTestId ?? 'core-zip-code-input'}
            />
            {icon}
          </div>
          {button}
        </div>
      </label>
      <div className="hc-help-text">{helpText}</div>
      <div className="hc-error-text">{errorText}</div>
    </FormGroup>
  );
}
